import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import { Icon } from '../icon';
import type { ReloadButtonProps as Props } from './types';

export const ReloadButton = memo(
  ({
    onReload,
    className,
    icon,
    iconProps,
    children,
    title,
    ...props
  }: Props) => {
    return (
      <Button
        className={classnames('ReloadButton', className)}
        variant="outlined"
        color="inherit"
        size="medium"
        {...props}
        onClick={onReload}
      >
        {children || title || 'reload'}
        {icon !== false && <Icon name={icon || 'reload'} />}
      </Button>
    );
  }
);

ReloadButton.displayName = 'ReloadButton';
